import React, { useEffect, useState, useRef } from 'react';
import { Clock, Zap, CheckCircle } from 'lucide-react';
import { Button } from '../ui/Button';
export function Upsell() {
  const [timeLeft, setTimeLeft] = useState(13 * 60 + 30); // 13:30 in seconds
  const lastUpdateRef = useRef(Date.now());
  useEffect(() => {
    let animationFrameId: number;
    const updateTimer = () => {
      const now = Date.now();
      const elapsed = Math.floor((now - lastUpdateRef.current) / 1000);
      if (elapsed >= 1) {
        lastUpdateRef.current = now;
        setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
      }
      animationFrameId = requestAnimationFrame(updateTimer);
    };
    animationFrameId = requestAnimationFrame(updateTimer);
    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <section className="py-12 px-4 bg-gradient-to-br from-orange-50 via-white to-orange-50 relative overflow-hidden" data-id="element-315">
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#FF6B35 2px, transparent 2px)',
      backgroundSize: '30px 30px'
    }} data-id="element-316"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-317">
        {/* Timer Header */}
        <div className="text-center mb-6" data-id="element-318">
          <div className="inline-flex items-center gap-2 bg-orange-500 text-white px-6 py-3 rounded-full font-black text-lg mb-4 shadow-lg" data-id="element-319">
            <Clock className="w-5 h-5" data-id="element-320" />
            <span data-id="element-321">⏰ Esta oferta expira en:</span>
          </div>
          <div className="text-6xl md:text-7xl font-black text-orange-600 font-mono tabular-nums tracking-tight" data-id="element-322">
            {String(minutes).padStart(2, '0')}:
            {String(seconds).padStart(2, '0')}
          </div>
        </div>

        {/* Upsell Card */}
        <div className="bg-white rounded-3xl shadow-2xl border-4 border-orange-400 p-6 md:p-8 relative overflow-hidden" data-id="element-323">
          <div className="absolute top-0 left-0 right-0 h-2 bg-gradient-to-r from-orange-400 via-orange-500 to-orange-400" data-id="element-324"></div>

          <div className="flex items-center gap-3 mb-4" data-id="element-325">
            <div className="bg-orange-500 text-white p-3 rounded-xl" data-id="element-326">
              <Zap className="w-6 h-6" data-id="element-327" />
            </div>
            <h3 className="text-2xl md:text-3xl font-black text-gray-900" data-id="element-328">
              ⚡Oferta especial — Solo por hoy
            </h3>
          </div>

          <div className="mb-6" data-id="element-329">
            <h4 className="text-3xl md:text-4xl font-black text-orange-600 mb-3 font-serif" data-id="element-330">
              Agrega: La Dieta Antiinflamatoria Canina
            </h4>
            <p className="text-lg md:text-xl text-gray-700 leading-relaxed font-medium" data-id="element-331">
              50 recetas naturales para prevenir enfermedades y mejorar la salud
              de tu perro. El complemento perfecto para potenciar los
              resultados.
            </p>
          </div>

          <div className="bg-orange-50 border-2 border-orange-200 rounded-xl p-4 mb-6" data-id="element-332">
            <div className="flex items-center gap-2 mb-2" data-id="element-333">
              <CheckCircle className="w-5 h-5 text-orange-600" data-id="element-334" />
              <span className="font-bold text-gray-800" data-id="element-335">
                Reduce inflamación y dolor articular
              </span>
            </div>
            <div className="flex items-center gap-2 mb-2" data-id="element-336">
              <CheckCircle className="w-5 h-5 text-orange-600" data-id="element-337" />
              <span className="font-bold text-gray-800" data-id="element-338">
                Fortalece el sistema inmunológico
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-339">
              <CheckCircle className="w-5 h-5 text-orange-600" data-id="element-340" />
              <span className="font-bold text-gray-800" data-id="element-341">
                Previene enfermedades crónicas
              </span>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mb-6" data-id="element-342">
            <div className="flex items-baseline gap-3" data-id="element-343">
              <span className="text-3xl md:text-4xl font-black text-gray-400 line-through" data-id="element-344">
                $9.99
              </span>
              <span className="text-5xl md:text-6xl font-black text-orange-600" data-id="element-345">
                $3.99
              </span>
              <span className="text-xl text-gray-600 font-bold" data-id="element-346">USD</span>
            </div>
            <div className="bg-orange-100 text-orange-800 font-black px-4 py-2 rounded-lg text-sm uppercase" data-id="element-347">
              60% de descuento
            </div>
          </div>

          <Button variant="primary" size="lg" className="w-full bg-orange-500 hover:bg-orange-600 text-white font-black text-xl md:text-2xl py-6 rounded-2xl shadow-xl border-4 border-orange-600 transform transition-all hover:scale-105" data-id="element-348">
            🐾 AGREGAR A MI PEDIDO
          </Button>

          <p className="text-center text-sm text-gray-500 mt-4 font-medium" data-id="element-349">
            Esta oferta solo está disponible en esta página y expira cuando el
            temporizador llegue a 0:00
          </p>
        </div>
      </div>
    </section>;
}